import { render, staticRenderFns } from "./SubscriptionItem.vue?vue&type=template&id=48660a05&scoped=true&"
import script from "./SubscriptionItem.vue?vue&type=script&lang=js&"
export * from "./SubscriptionItem.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionItem.vue?vue&type=style&index=0&id=48660a05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48660a05",
  null
  
)

export default component.exports